import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { withRouter } from "react-router-dom";
import { fixMediaUrl } from "../../../Shared/api/drupal/drupalApi";
import { searchParams } from "../../../Shared/components/Collection/CollectionOverview/CollectionOverviewUtils";
import { features } from "../../../Shared/features";
import { WiseConfig } from "../../../Shared/features/WiseConfig";
import { getDrupalSearchImage } from "../../custom_api/api";
import { trackCollectionSearch } from "./library/tracking";
class CollectionSearchBar extends React.Component {
    async componentDidMount() {
        let searchImageData = await getDrupalSearchImage();
        if (searchImageData !== "error") {
            this.setState((s)=>({
                    ...s,
                    searchImage: searchImageData
                }));
        }
    }
    render() {
        const { query, searchImage } = this.state;
        const collectionConfig = features().collection;
        const search = ()=>{
            trackCollectionSearch(query);
            collectionConfig == 'off' || collectionConfig.isInSoftLaunch ? window.open(`${WiseConfig().BaseUrl}/wise-apps/opac/branch/${WiseConfig().LibraryId}/catalog/search?qs=${query}`) : this.props.history.push({
                pathname: collectionConfig.route,
                search: searchParams({
                    query
                })
            });
        };
        const style = searchImage == 'loading' ? {
            backgroundImage: 'none'
        } : searchImage != 'error' && searchImage ? {
            backgroundImage: `url(${fixMediaUrl(searchImage)})`
        } : null;
        return /*#__PURE__*/ _jsxs("section", {
            className: "search-wrapper",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "form form--search search container--m align--center",
                    children: [
                        /*#__PURE__*/ _jsx("label", {
                            htmlFor: "collection-search",
                            className: "form__label search__label",
                            children: /*#__PURE__*/ _jsxs("h2", {
                                className: "form__title title--m",
                                children: [
                                    "Zoek in de collectie ",
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "sr-text",
                                        children: "(externe link)"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "search__input-container form__item--icon left",
                            children: [
                                /*#__PURE__*/ _jsx("input", {
                                    id: "collection-search",
                                    className: "form__input search__input",
                                    type: "text",
                                    onChange: (e)=>this.setState({
                                            ...this.state,
                                            query: e.currentTarget.value
                                        }),
                                    value: query,
                                    onKeyPress: (e)=>e.key == "Enter" ? search() : {},
                                    placeholder: "Thema, auteur, titel of ISBN"
                                }),
                                /*#__PURE__*/ _jsx("button", {
                                    type: "button",
                                    className: "button button--primary button--arrow search__button",
                                    onClick: search,
                                    children: /*#__PURE__*/ _jsx("span", {
                                        children: "Zoeken"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("svg", {
                                    className: "form__icon",
                                    width: "20px",
                                    height: "20px",
                                    "aria-hidden": "true",
                                    children: /*#__PURE__*/ _jsx("use", {
                                        xlinkHref: "#icon--search-dnb"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "after",
                    style: style,
                    "aria-hidden": "true"
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = {
            searchImage: "loading",
            query: ""
        };
    }
}
export default withRouter(CollectionSearchBar); /* TH: Added to styleguide! */ 
